import { useQuery } from 'react-query';
import { getDefaultDashboard } from 'App/services/ReportEngineService';

function useFetchDefaultInsightsDashboard() {
    return useQuery(['insights', 'embedUrl'], () => getDefaultDashboard(), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchDefaultInsightsDashboard;
